import {
    RESET_QUESTIONNAIRE,
    INITIATE_QUESTIONNAIRE_SUCCESS,
    SEND_QUESTION_SUCCESS,
    REMOVE_LAST_QUESTION_SUCCESS,
    UPDATE_CURRENT_QUESTIONNAIRE_SUCCESS,
} from '../../constants';

const initialQuestionnaireState = {
    sessionID: null,
    goBack: null,
    questionnaire: {
        id: null,
        answers: [],
        metaData: {
            question: null,
            questionType: null,
        },
        currentAnswer: null,
    },
    questionnaireState: [],
    visibleQuestions: ['P1Q1', 'P1Q2'],
    previousShieldData: [],
    currentShieldData: [],
};

export default function questionnaireReducer(
    state = initialQuestionnaireState,
    action,
) {
    switch (action.type) {
        case 'UPDATE_SHIELD_DATA': {
            const foo = {
                ...state,
                previousShieldData: [
                    ...action.payload.previousShieldData,
                ],
                currentShieldData: [
                    ...action.payload.currentShieldData,
                ],
            };
            return foo;
        }
        case RESET_QUESTIONNAIRE:
            return initialQuestionnaireState;
        case INITIATE_QUESTIONNAIRE_SUCCESS: {
            return {
                ...state,
                goBack: false,
                sessionID: action.payload.sessionID,
                questionnaire: action.payload.questionnaire,
            };
        }
        case SEND_QUESTION_SUCCESS: {
            return {
                ...state,
                goBack: false,
                sessionID: action.payload.sessionID,
                questionnaire: action.payload.questionnaire,
                questionnaireState: [
                    ...state.questionnaireState,
                    action.payload.questionState,
                ],
            };
        }
        case REMOVE_LAST_QUESTION_SUCCESS:
            return {
                ...state,
                questionnaireState: action.questionnaireState,
            };
        case UPDATE_CURRENT_QUESTIONNAIRE_SUCCESS:
            return {
                ...state,
                goBack: true,
                questionnaire: action.questionState,
            };
        default:
            return state;
    }
}
